// Vuex module — Penyiapan Token Approver Diskon (P26_0031 AC-08.2).
//
// Halaman IT: /offline-stores/spg-token. Endpointnya di
// routes/routes/unionweb.php grup `/spg-token`, dijaga auth:api + access.
//
// Tokennya sendiri TIDAK pernah lewat sini — tidak saat diterbitkan sekalipun
// (NFR-03.1). Yang dibawa cuma status, waktu, dan grant yang kurang. Jangan
// tambahkan field token ke state ini; layar tidak boleh punya cara menampilkannya.
import $axios from "../../api";

const PREFIX = "unionweb/spg-token";

const state = () => ({
  loading: false,
  // Penyetuju diskon (user HRIS pemegang hris.approval.diskon) yang akun
  // nfdashv2-nya berperan storemanager, + keadaan tokennya.
  approvers: [],
});

const mutations = {
  SET_LOADING(s, v) { s.loading = v; },
  SET_APPROVERS(s, v) { s.approvers = v || []; },
  // Perbarui satu baris di tempat setelah terbit/cabut — menarik ulang seluruh
  // daftar demi satu baris membuat layar berkedip di ponsel (NFR-04.3).
  PATCH_APPROVER(s, row) {
    if (!row) return;
    s.approvers = s.approvers.map((a) =>
      a.user_id === row.user_id ? { ...a, ...row } : a
    );
  },
};

const actions = {
  async fetchAll({ commit }) {
    commit("SET_LOADING", true);
    try {
      const res = await $axios.get(`${PREFIX}/list`);
      const data = res.data?.data || {};
      commit("SET_APPROVERS", data.approvers);
      return data;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  // POST terbitkan/perbarui. Mengembalikan baris approver yang sudah diperbarui.
  // Akunnya TIDAK dikirim: server menurunkannya dari approver itu sendiri (AC-04.6).
  async issueToken({ commit }, { userId }) {
    const res = await $axios.post(`${PREFIX}/issue`, {
      user_id: userId,
    });
    const row = res.data?.data?.approver;
    commit("PATCH_APPROVER", row);
    return row;
  },

  // POST cabut. Backend tidak mengembalikan baris utuh, jadi yang di-patch cuma
  // status — sisa field (nama, akun, issued_at) tetap seperti apa adanya.
  async revokeToken({ commit }, userId) {
    const res = await $axios.post(`${PREFIX}/revoke`, { user_id: userId });
    const data = res.data?.data;
    commit("PATCH_APPROVER", { user_id: userId, token_status: data?.token_status || "revoked" });
    return data;
  },
};

const getters = {
  // Penyetuju yang tokennya aktif TAPI akunnya kehilangan grant — grant bisa
  // dicabut dari menu Role setelah token dicetak, dan tanpa penanda ini halaman
  // terlihat sehat sementara persetujuan diskon sudah pasti gagal.
  brokenApprovers: (s) =>
    s.approvers.filter(
      (a) => a.token_status === "active" && (a.missing_grants || []).length > 0
    ),
};

export default { namespaced: true, state, mutations, actions, getters };
